module.exports = __webpack_public_path__ + "img/earth.08274ef3.svg";